var handle_array = ["12-pocket-rotating-greeting-card-display-7-x-5","12-pocket-postcard-rotating-display-6-x-4","3-pocket-postcard-rotating-display-6-x-4","4-pocket-rotating-greeting-card-display-7-x-5","4-pocket-postcard-rotating-display-6-x-4","8-pocket-rotating-greeting-card-display-7-x-5","8-pocket-postcard-rotating-display-6-x-4","custom-printed-acrylic-sign-holder-with-1-stainless-steel-standoffs","now-hiring-vinyl-banner-sign-with-grommets","3-pocket-revolving-brochure-holder-9-x-11-brochures-or-magazines","polycarbonate-disc-clear"];
 var productid_array = ["5861806899264","4812486508608","4802545451072","4516173971520","4802539585600","4812480282688","4802543681600","4812481429568","4802543976512"];
 var hide_price=1;
 var hide_ajaxaddtocart =1;
 var display_phone = 1;
 var phone_no='520.770.7890';
 var display_call_for_price=1;
 var call_for_price_label = 'Request for Price';
 var css_style_button='background-color: #000000;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
 var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
 var enable_outofstock = 1;
 var price_selector='.button-group, .total-price, .wishlist, .compare, .product-compare-btn, .btn-beatanyprice';
 var cart_selector='#AddToCart-product-template';
 var phone_no_label = 'Call for Price';
 var required_field='name,email,comment';
 var contact_form_heading='Call for Price for';
 var parent_selector='.product_shop, .header-search__results-wrapper';
 var unavailable_label='Unavailable';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='no';
 var enable_cfp_for_all_products='no';
 var hide_cfp_btn_on_collection='no';
 var hide_phone_no_on_collection='no';
 var enable_whatsapp = 0;
 var whatsapp_number = '';
 var whatsapp_message = 'Hi {store_name} I am interested in this product. {product_url}. Price please ?';
 var hide_whatsapp_button_on_collection = 0;
 var whatsapp_button_text ='';
 var whatsapp_button_background_color ='#000000';
 var whatsapp_button_text_color ='#ffffff';
 var whatsapp_css_style_button ='';
 var phoneno_css_style_button ='';